function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}"));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "enterprise");

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 8,
  y: 8,
  width: 2,
  height: 4
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 8,
  y: 14,
  width: 2,
  height: 4
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 14,
  y: 8,
  width: 2,
  height: 4
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 14,
  y: 14,
  width: 2,
  height: 4
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 8,
  y: 20,
  width: 2,
  height: 4
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 14,
  y: 20,
  width: 2,
  height: 4
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M30,14a2,2,0,0,0-2-2H22V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V30H30ZM4,4H20V28H4ZM22,28V14h6V28Z"
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  id: "_Transparent_Rectangle_",
  "data-name": "<Transparent Rectangle>",
  className: "cls-1",
  width: 32,
  height: 32
});

var SvgEnterpriseIcon = function SvgEnterpriseIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#8E8B99",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    id: "enterprise",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEnterpriseIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/enterpriseIcon.c16146b0.svg";
export { ForwardRef as ReactComponent };